require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./reviews-gath-surf-converible.json") })
        }
      }, "path---reviews-gath-surf-converible");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---reviews-gath-surf-converible!./.cache/json/reviews-gath-surf-converible.json
// module id = 686
// module chunks = 231608221292675